<script setup>
import {computed, onMounted, ref} from 'vue'
import Width from "@/pages/Index/Width.vue";
import Title from "@/components/Title/Title.vue";
import MoreButton from "@/pages/Index/components/MoreButton.vue";
import axios from "axios";
import {useStore} from "vuex";
import {extractText} from "../../../utils";
import SvgIcon from "@/components/SvgIcon/SvgIcon.vue";
import {useRouter} from "vue-router";

// const props = defineProps({
// 	customerCase: {
// 		type: Array,
// 		default: () => []
// 	}
// })

const store = useStore()
const router = useRouter()

const customerCase = ref([])
const currentItem = ref(null)

const currentLang = computed(() => store.getters.currentLanguage)

const getCustomerCase = async () => {
	const res = await axios.get('/api/api/strength?take=3')
		.catch(err => {
			throw new Error(err.message)
		})
	customerCase.value = res.data
	currentItem.value = res.data[0]
	console.log('res --------->', res)
}

const handleMouseEnter = (item) => {
	currentItem.value = item
}

const handleToPage = () => {
	router.push({
		path: '/customer-case'
	})
}

const handleToCaseDetails = (id) => {
	router.push({
		path: `/customer-case/${id}`
	})
}

onMounted(() => {
	getCustomerCase()
})
</script>

<template>
	<div class="customer-case">
		<Width>
			<div class="customer-case__header">
				<div class="title-pc">
					<Title
						:title="$t('section.CustomerCase.title')"
						mode="dark"
						position="left"
					/>
				</div>
				
				<div class="title-mobile">
					<Title
						:title="$t('section.CustomerCase.title')"
						mode="dark"
						position="center"
					/>
				</div>
				
				<MoreButton
					class="more-button-pc"
					:btn-text="$t('section.newsBlock.more')"
					@click="handleToPage"
				/>
			</div>
			
			<div class="customer-case__content">
				<div
					class="customer-case__list customer-case__list--pc"
				>
					<div
						class="customer-case__list-item item"
						:class="{
							'customer-case__list-item--hover': item?.id === currentItem?.id
						}"
						v-for="(item, index) in customerCase"
						:key="index"
						@mouseenter="handleMouseEnter(item)"
						:style="{
							'background-image': currentItem?.id === item?.id ? `url(${currentItem.image}` : ''
						}"
					>
						<div class="item__title">
							<div class="line-clamp-1" style="font-weight: bold;">
								{{ item?.[`title_${currentLang}`] ?? item?.title_cn }}
							</div>
						</div>
						
						<div class="item__bottom">
							<div class="item__desc line-clamp-3">
								{{ extractText(item?.[`content_${currentLang}`] || item?.content_cn) }}
							</div>
							
							<div class="item__cover">
								<el-image
									:src="item.image"
									style="width: 100%; height: 100%;"
									fit="cover"
									lazy
								/>
							</div>
						</div>
						
						<div
							class="item__left-info"
							:class="{
								'item__left-info--hover': item?.id === currentItem?.id
							}"
						>
<!--							<SvgIcon name="logo" class-name="left-icon" />-->
							<div class="left-icon">
								<img
									:src="item?.left_top_image"
									style="width: 100%;height: 100%;object-fit: contain;"
									v-if="item?.left_top_image"
									loading="lazy"
								/>
							</div>
							
							<div class="info">
								<div
									class="info__title line-clamp-1"
									@click="handleToCaseDetails(item?.id)"
								>
									{{ item?.[`title_${currentLang}`] ?? item?.title_cn }}
								</div>
								
								<div class="info__desc line-clamp-3">
									{{ extractText(item?.[`content_${currentLang}`] ?? item?.content_cn) }}
								</div>
							</div>
						</div>
						
						<div class="mask" />
					</div>
				</div>
				
				<div
					class="customer-case__list customer-case__list--mobile"
				>
					<div
						class="customer-case__list-item item"
						v-for="(item, index) in customerCase"
						:key="index"
					>
						<div
							class="item__title"
							@click="handleToCaseDetails(item?.id)"
						>
							<div
								class="line-clamp-1"
								style="font-weight: bold;"
							>
								{{ item?.[`title_${currentLang}`] ?? item?.title_cn }}
							</div>
						</div>
						
						<div class="item__bottom">
							<div class="item__desc line-clamp-3">
								{{ extractText(item?.[`content_${currentLang}`] ?? item?.content_cn) }}
							</div>
							
							<div class="item__cover">
								<el-image
									:src="item.image"
									style="width: 100%; height: 100%;"
									fit="cover"
								/>
							</div>
						</div>
					</div>
					
					<MoreButton
						:btn-text="$t('section.newsBlock.more')"
						@click="handleToPage"
					/>
				</div>
			</div>
		</Width>
	</div>
</template>

<style scoped lang="less">
.customer-case {
	padding: 72px 0;
	&__header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 50px;
		
		.title-mobile {
			display: none;
		}
	}
	
	&__list {
		display: flex;
		align-items: flex-end;
		height: 405px;
		
		&--mobile {
			display: none;
		}
		
		&-item{
			//will-change: transform, width, height;
			//transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
			//transform: translateZ(0);
			padding: 30px;
			background-color: #fff;
			margin-right: 20px;
			//transition: all .3s;
			width: calc(100% / 3);
			//flex: 1;
			height: 80%;
			border-radius: 16px;
			background-size: cover;
			position: relative;
			overflow: hidden;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			
			.mask {
				display: none;
				position: absolute;
				left: 0;
				right: 0;
				top: 0;
				bottom: 0;
				z-index: 0;
				background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));
			}
			
			&:last-child {
				margin-right: 0;
			}
			
			&--hover {
				padding: 0;
				height: 100%;
				width: 50%;
				
				.mask {
					display: block;
				}
				
				.item {
					&__title,
					&__bottom {
						opacity: 0;
						display: none;
					}
					
					&__left-info--hover {
						display: flex !important;
						flex-direction: column;
						justify-content: space-between;
						opacity: 1 !important;
					}
				}
			}
			
			.item {
				font-size: 18px;
				color: #3D3D3D;
				
				&__title {
					font-size: 18px;
					font-weight: bold;
					cursor: pointer;
					//padding-bottom: 20px;
				}
				
				&__bottom {
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					
				}
				
				&__desc {
					line-height: 28px;
				}
				
				&__cover {
					border-radius: 4px;
					overflow: hidden;
					margin-top: 20px;
					height: 130px;
				}
				
				&__left-info {
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					z-index: 1;
					//display: none;
					opacity: 0;
					padding: 30px;
					box-sizing: border-box;
					width: 40%;
					height: 100%;
					background: linear-gradient(325deg, rgba(209, 23, 14, 0.8) 3%, rgba(244, 103, 96, 0.8) 100%);
					color: #fff;
					backdrop-filter: blur(20px);
					
					.left-icon {
						width: 78px;
						height: 78px;
					}
					
					.info {
						
						&__title {
							font-size: 24px;
							font-weight: bold;
							cursor: pointer;
						}
						
						&__desc {
							margin-top: 20px;
							font-size: 18px;
							line-height: 30px;
						}
						
					}
				}
			}
		}
	}
	
}

@media only screen and (max-width: 1200px) {
	.customer-case {

		&__header {

		}
		
		.item {
			
			&__left-info {
				width: 50%;
			}
		}
	}
}

@media only screen and (max-width: 1024px) {
	.customer-case {
		padding: 30px 0;
		
		&__header {
			margin-bottom: 20px;
		}
		
		&__list {
			
			.item {
				
				&__title {
					font-size: 16px;
				}
				
				&__desc {
					font-size: 18px;
					line-height: 28px;
				}
				
			}
		}
	}
}

@media only screen and (max-width: 768px) {
	.customer-case {
		padding: 30px 0;
		
		&__header {
			margin-bottom: 20px;
			justify-content: center;
			
			.more-button-pc {
				display: none;
			}
			
			.title-pc {
				display: none;
			}
			
			.title-mobile {
				display: block;
			}
		}
		
		&__list {
			display: flex;
			flex-direction: column;
			align-items: center;
			height: auto;
			width: 100%;
			
			&-item {
				width: 100%;
				margin-right: 0;
				margin-bottom: 20px;
				padding: 20px;
				
				&:last-child {
					margin-bottom: 0;
				}
			}
			
			
			.item {
				
				&__title {
					font-size: 18px;
					padding-bottom: 12px;
				}
				
				&__cover {
					margin-top: 12px;
					height: 188px;
				}
				
			}
			
			&--pc {
				display: none;
			}
		}
	}
}
</style>